module.exports = __webpack_public_path__ + "static/Quotes-Banner-0f5752e48d13c622b55bf321798f7df8.png";